module.exports = __webpack_public_path__ + "img/V90.0353c5ff.jpg";